import React, { useEffect, useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { usePricing } from '../hooks/usePricing';

function OrderListScreen() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { formatPrice } = usePricing();

    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setLoading(true);
                const config = {
                    headers: {
                        Authorization: `Bearer ${userInfo.token}`,
                    },
                };

                const { data } = await axios.get('/api/orders/', config);
                setOrders(data);
                setLoading(false);
            } catch (err) {
                setError(err.response?.data?.detail || err.message);
                setLoading(false);
            }
        };

        if (!userInfo || !userInfo.isAdmin) {
            navigate('/login');
        } else {
            fetchOrders();
        }
    }, [navigate, userInfo]);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString();
    };

    return (
        <div>
            <h1>Orders</h1>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <Table striped bordered hover responsive className='table-sm'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>USER</th>
                            <th>DATE</th>
                            <th>TOTAL</th>
                            <th>PAID</th>
                            <th>DELIVERED</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders && orders.map((order) => (
                            <tr key={order.OrderId}>
                                <td>#{order.OrderId}</td>
                                <td>{order.user && order.user.name}</td>
                                <td>{formatDate(order.created_at)}</td>
                                <td>{formatPrice(order.total_price)}</td>
                                <td>
                                    {order.is_paid ? (
                                        <Badge bg="success">{formatDate(order.paid_at)}</Badge>
                                    ) : (
                                        <Badge bg="warning" text="dark">Not Paid</Badge>
                                    )}
                                </td>
                                <td>
                                    {order.is_delivered ? (
                                        <Badge bg="success">{formatDate(order.delivered_at)}</Badge>
                                    ) : (
                                        <Badge bg="secondary">Not Delivered</Badge>
                                    )}
                                </td>
                                <td>
                                    <LinkContainer to={`/order/${order.OrderId}`}>
                                        <Button variant='light' className='btn-sm'>
                                            Details
                                        </Button>
                                    </LinkContainer>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
}

export default OrderListScreen;
